import React from 'react';
import Reflux from 'reflux';
import UserSessionStore from 'flux/stores/UserSessionStore';
import TeamViewStore from 'flux/stores/TeamViewStore';

const PENDO_API_KEY = '0c8210e3-53b4-4c97-a8e1-20bfdacef3e8';

const isAutomatedTestEmail = (email) => {
  if (!email) return true;
  return (
    email.includes('+synthetics') &&
    (email.includes('@shoflo') || email.includes('@lasso'))
  );
}

function getIsPendoLoaded() {
  return typeof window !== 'undefined' && window.pendo !== undefined;
}

export default React.createClass({
  displayName: 'PendoContainer',

  mixins: [
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connect(TeamViewStore, 'team'),
  ],

  getInitialState() {
    return {
      pendoInitialized: false,
    };
  },

  componentDidMount() {
    this._loadPendoScript();
    this._initializePendo();
  },

  componentDidUpdate() {
    this._initializePendo();
  },

  _loadPendoScript() {
    if (process.env.NODE_ENV !== 'production') return;
    if (getIsPendoLoaded()) return;

    (function (apiKey) {
      (function (p, e, n, d, o) {
        var v, w, x, y, z;
        o = p[d] = p[d] || {};
        o._q = o._q || [];
        v = [
          'initialize',
          'identify',
          'updateOptions',
          'pageLoad',
          'track',
          'trackAgent',
        ];
        for (w = 0, x = v.length; w < x; ++w)
          (function (m) {
            o[m] =
              o[m] ||
              function () {
                o._q[m === v[0] ? 'unshift' : 'push'](
                  [m].concat([].slice.call(arguments, 0)),
                );
              };
          })(v[w]);
        y = e.createElement(n);
        y.async = !0;
        y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
        z = e.getElementsByTagName(n)[0];
        z.parentNode.insertBefore(y, z);
      })(window, document, 'script', 'pendo');
    })(PENDO_API_KEY);
  },

  _initializePendo() {
    if (process.env.NODE_ENV !== 'production') return;
    if (!getIsPendoLoaded()) return;

    const { user, team } = this.state;

    if (!user || !team) return;

    const email = user.get('email');
    if (isAutomatedTestEmail(email)) return;

    const options = {
      visitor: {
        id: user.get('_id'),
        firstName: user.get('firstName'),
        lastName: user.get('lastName'),
        email: user.get('email'),
      },
      account: {
        id: team.get('_id'),
        accountName: team.get('title'),
      },
    };

    if (this.state.pendoInitialized) {
      window.pendo.updateOptions(options);
    } else {
      window.pendo.initialize(options);
      this.setState({ pendoInitialized: true });
    }
  },

  render() {
    return null;
  },
});
